var map = {
	"./music-instructions.json": 4466,
	"./music-library-intro2024.json": 4467,
	"./music-library-launch2024.json": 4468,
	"./music-progression.json": 4469,
	"./startSourcesAdvanced.json": 4470,
	"./startSourcesSimple.json": 4471,
	"./startSourcesSimple2.json": 4472,
	"./startSourcesTracks.json": 4473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4245;